@if (!isLoadingLogs && !isLoadingRegisterForm) {
	@if (viewType === 'edit') {
		<div class="inconsistency-section-header" (click)="collapseForm.INCONSISTENCY_EXCEPTION = !collapseForm.INCONSISTENCY_EXCEPTION">
			<span>{{ labels.lbl_geral_excecoes_do_ativo }}</span>
			<span><fa-icon [icon]="collapseForm.INCONSISTENCY_EXCEPTION === false ? icons.faAngleUp : icons.faAngleDown"> </fa-icon></span>
		</div>
		@if (collapseForm.INCONSISTENCY_EXCEPTION === false) {
			<div class="inconsistency-content">
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_data_expiracao }}:</span>

					<input type="date" [(ngModel)]="exceptionInconsistencyDate" />
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_nota }}*:</span>

					<textarea [(ngModel)]="exceptionInconsistencyNotes" style="resize: vertical"></textarea>
				</div>

				<div class="exception-list">
					@for (exceptionType of availableInconsistencyTypes; track exceptionType) {
						<div class="exception-item">
							<label>
								<input
									type="checkbox"
									name="exceptionType_{{ exceptionType.id }}"
									[(ngModel)]="exceptionType.checked"
									(ngModelChange)="onInconsistencySelected(exceptionType, $event)" />
								<span>{{ labels[exceptionType.label] }}</span>
							</label>
						</div>
					}
				</div>

				<div class="button-container">
					<msp-button (click)="saveExceptionsInconsistencies()" [loading]="isSavingExceptions">{{
						labels.lbl_geral_salvar
					}}</msp-button>
				</div>
			</div>
		}
	}

	@if (inconsistenciesExceptionLogs.length > 0) {
		<div class="inconsistency-section-header" (click)="collapseForm.INCONSISTENCY_LOGS = !collapseForm.INCONSISTENCY_LOGS">
			<span>{{ labels.lbl_chamado_acompanhamento }}</span>
			<span><fa-icon [icon]="collapseForm.INCONSISTENCY_LOGS === false ? icons.faAngleUp : icons.faAngleDown"> </fa-icon></span>
		</div>
		@if (collapseForm.INCONSISTENCY_LOGS === false) {
			<div class="inconsistency-content">
				<div class="exception-log-container">
					@for (log of inconsistenciesExceptionLogs; track log) {
						<div class="log">
							<div class="log-header">
								<span class="log-date">{{ dateService.formatDate(log.created_at) }}</span>
								<span class="log-user">{{ log.analyst_name }}</span>
							</div>
							<div class="log-content">
								@for (change of log.changes | keyvalue; track change) {
									<div>{{ change.value.label }}:</div>
									<div class="change">
										@for (oldChange of change.value.old; track oldChange) {
											@switch (change.value.type) {
												@case ('date') {
													<span>{{ dateService.formatDate(oldChange) }}</span>
												}
												@default {
													<span>{{ oldChange }}</span>
												}
											}
										}
									</div>
									<div>→</div>
									<div class="change">
										@for (newChange of change.value.new; track newChange) {
											@switch (change.value.type) {
												@case ('date') {
													<span>{{ dateService.formatDate(newChange) }}</span>
												}
												@default {
													<span>{{ newChange }}</span>
												}
											}
										}
									</div>
								}
							</div>
						</div>
					}
				</div>
			</div>
		}
	}

	<div class="inconsistency-section-header" (click)="collapseForm.INCONSISTENCY_LINKED = !collapseForm.INCONSISTENCY_LINKED">
		<span>{{ labels.lbl_geral_vinculadas_ao_ativo }}</span>
		<span><fa-icon [icon]="collapseForm.INCONSISTENCY_LINKED === false ? icons.faAngleUp : icons.faAngleDown"> </fa-icon></span>
	</div>
	@if (collapseForm.INCONSISTENCY_LINKED === false && inconsistenciesLogs?.length > 0) {
		<div class="inconsistency-content">
			@for (inconsistency of inconsistenciesLogs; track inconsistency) {
				<div
					class="activity-card inconsistency-card"
					(click)="openInconsistency(inconsistency.inconsistency_id.toString())"
					[title]="'Clique para acessar a inconsistência #' + inconsistency.inconsistency_id">
					<div class="card-header">
						<span class="header-link">
							ID {{ inconsistency.inconsistency_id }} - {{ labels[inconsistency.inconsistency_type_name] }} <br />
							<strong
								>{{ labels[inconsistency.status_name] }} <br />
								{{ labels.lbl_geral_prioridade }}: {{ inconsistency.priority }}
							</strong>
						</span>
					</div>
					<div class="card-content">
						<div class="content-info">
							<span class="content-date"> {{ dateService.formatDate(inconsistency.creation_date) }}</span>
							<span class="content-notes" [innerHTML]="inconsistency.inconsistency_reason"></span>
						</div>
					</div>
				</div>
			}
		</div>
	}

	@if (collapseForm.INCONSISTENCY_LINKED === false && (!inconsistenciesLogs || inconsistenciesLogs.length === 0)) {
		<div class="inconsistency-content">
			{{ labels.lbl_geral_nenhuma_inconsistencia_vinculada_ativo }}
		</div>
	}
}

@if (isLoadingLogs || isLoadingRegisterForm) {
	<!-- <cpi-square-post-loading-effect [height]="'8rem'"> </cpi-square-post-loading-effect> -->
	<div class="loading-container">
		<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
	</div>
}
